import React from "react";
import { CatGroup } from "./CatOrderTable";

export interface CatGroupPanelProps {
	groups: CatGroup[];
	draggedCat: string | null;
	onGroupDragStart: (e: React.DragEvent, cat: string) => void;
	onGroupDragOver: (e: React.DragEvent) => void;
	onGroupDrop: (e: React.DragEvent, cat: string) => void;
	onDragEnd: () => void;
}

const CatGroupPanel: React.FC<CatGroupPanelProps> = ({
	groups,
	draggedCat,
	onGroupDragStart,
	onGroupDragOver,
	onGroupDrop,
	onDragEnd,
}) => (
	<div className="sticky top-4 self-start w-36 flex flex-col gap-1.5 shrink-0">
		<p className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-1">CAT Order</p>
		{groups.map((group) => (
			<div
				key={group.cat}
				draggable
				onDragStart={(e) => onGroupDragStart(e, group.cat)}
				onDragOver={onGroupDragOver}
				onDrop={(e) => onGroupDrop(e, group.cat)}
				onDragEnd={onDragEnd}
				className={`flex items-center gap-2 px-3 py-2 bg-indigo-50 border border-indigo-200 rounded-md cursor-move select-none transition-opacity ${
					draggedCat === group.cat ? "opacity-40" : "hover:bg-indigo-100"
				}`}
			>
				<svg className="w-3 h-3 text-indigo-400 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
					<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 8h16M4 16h16" />
				</svg>
				<span className="text-xs font-semibold text-indigo-700 truncate">{group.cat}</span>
				<span className="ml-auto text-xs text-indigo-400 flex-shrink-0">{group.items.length}</span>
			</div>
		))}
	</div>
);

export default CatGroupPanel;
